var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import PaymentVoucherService from '../../api/PaymentVoucherService';
import { EBillType } from "../../enum/EBillType";
import { toDetail } from '../../helper/util';
import Header from './components/OnlinePayHeaderV2.vue';
import { UrlHelper } from '../../helper/UrlWrapper';
var initFormData = {
    business_id: [],
    time_type: 1,
    is_payment_confirm: 0,
    order_type: 0,
};
var OnlinePayV2 = (function (_super) {
    __extends(OnlinePayV2, _super);
    function OnlinePayV2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.tableHeight = document.documentElement.clientHeight - 240;
        _this.total = 0;
        _this.certModalVisbile = false;
        _this.certModalType = 1;
        _this.selectRows = [];
        _this.selectRow = {};
        _this.comment = '';
        _this.order_map = [];
        _this.top_money = {};
        _this.FormData = __assign({}, initFormData);
        return _this;
    }
    OnlinePayV2.prototype.openDio = function (type, row) {
        var _this = this;
        this.order_map = [];
        this.comment = '';
        this.certModalType = 1;
        var can_confirm = true;
        if (type == 1) {
            this.selectRow = row;
            this.order_map.push({ t: row.t, other_order_id: row.other_order_id });
        }
        else if (type == 2) {
            this.certModalType = 2;
            this.selectRow = row;
        }
        else {
            if (this.selectRows.length == 0) {
                this.$message.error('请至少选择一项进行确认');
                return;
            }
            var money_1 = 0, pay_money_1 = 0, diff_money_1 = 0;
            this.selectRows.forEach(function (item, index) {
                if (item.is_payment_confirm != 0) {
                    _this.$message.error('仅可选择待确认的支付记录');
                    can_confirm = false;
                    return;
                }
                _this.order_map.push({ t: item.t, other_order_id: item.other_order_id });
                money_1 += parseFloat(item.money);
                pay_money_1 += parseFloat(item.pay_money);
                diff_money_1 += parseFloat(item.diff_money);
            });
            this.selectRow.money = money_1;
            this.selectRow.pay_money = pay_money_1;
            this.selectRow.diff_money = diff_money_1;
        }
        if (can_confirm) {
            this.certModalVisbile = true;
        }
    };
    OnlinePayV2.prototype.created = function () {
        this.service = PaymentVoucherService.getInstance();
    };
    OnlinePayV2.prototype.mounted = function () {
    };
    OnlinePayV2.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    OnlinePayV2.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getOnlinePayListV2(Object.assign({}, this.filter, pager))
            .then(function (res) {
            loadingInstance.close();
            _this.listData = Array.isArray(res.data.data) ? res.data.data : [];
            _this.total = res.data.total;
            _this.top_money.money = res.data.money;
            _this.top_money.un_money = res.data.un_money;
            _this.top_money.order_reduction_money = res.data.order_reduction_money;
            _this.top_money.sub_money = res.data.sub_money;
            _this.top_money.balance_pay_money = res.data.balance_pay_money;
            _this.top_money.actual_money = res.data.actual_money;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    OnlinePayV2.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    OnlinePayV2.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
        }
        if (_.isDate(filter.e_time)) {
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        this.filter = filter;
        this.getList();
    };
    OnlinePayV2.prototype.certModalHide = function () {
        this.certModalVisbile = false;
    };
    OnlinePayV2.prototype.certModalConfirm = function (raw) {
        var _this = this;
        if (1 == raw.is_payment_confirm) {
            this.certModalVisbile = false;
            return;
        }
        if (this.comment.length > 50) {
            this.$message.error('备注请输入50字以内字数');
            return;
        }
        var param = {
            comment: this.comment,
            order_map: JSON.stringify(this.order_map),
        };
        console.log(param);
        this.service.confirmPayStatus(param).then(function (res) {
            console.log(res.data);
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success(res.data.msg || '操作成功');
            }
            _this.getList();
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
        this.certModalVisbile = false;
    };
    OnlinePayV2.prototype.selectable = function (row, index) {
        return row.is_payment_confirm == 0;
    };
    OnlinePayV2.prototype.exportOnlinePayData = function (filter) {
        var orderMap = [];
        this.selectRows.forEach(function (item) {
            orderMap.push(item.t + '_' + item.other_order_id);
        });
        var url = "supplierclientapi/purchaseorder/export_online_payment_list_v2?order_map=" + orderMap.join(",");
        var params = _.cloneDeep(filter);
        for (var key in params) {
            params[key] = (params[key] === undefined || params[key] === null) ? '' : params[key];
            url = UrlHelper.addParam(url, key, params[key]);
        }
        url = UrlHelper.addParam(url, "token", this.user.token);
        console.log(11111111, orderMap.join(','), url);
        location.href = url;
    };
    OnlinePayV2.prototype.toDetail = function (row, type) {
        if (type == 1) {
            toDetail(EBillType.PurOrder, row.order_id, this);
        }
        else {
            toDetail(EBillType.ShopAfterSales, row.other_order_id, this);
        }
    };
    OnlinePayV2 = __decorate([
        Component({
            components: {
                'list-header': Header,
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], OnlinePayV2);
    return OnlinePayV2;
}(Vue));
export default OnlinePayV2;
